module.exports = __webpack_public_path__ + "static/Posts-48153c1ba68ec92ce4a97b55a716f7dd.png";